import React, { useContext, useEffect, useState } from 'react';
import {BrowserRouter as Router, Route } from "react-router-dom";
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { Button } from '@mui/material';

import NewsHandler from '../admin-users/newsHandler';
import UserHandler from '../user-handler/userHandler';
import MendHandler from '../mend-handler/mendHandler';
import CourseHandler from '../course-handler/courseHandler';
import './admin-dashboard.css';
import { Switch } from 'react-router-dom/cjs/react-router-dom.min';
import Admin from '../admin-profile/Admin-profile';

import { MdAttachEmail } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import { FaAddressCard } from "react-icons/fa";
import { AuthContext } from '../../../shared/context/auth-context';

const AdminDashboard = () => {
 
  const auth = useContext(AuthContext);
  const { user } = useContext(AuthContext)
  const [news, setNews] = useState([]);
  const [isUser, setIsUser] = useState([]);
  const [mend, setMend] = useState([]);
  const [course, setCourse] = useState([]);
  const [book, setBook] = useState([]);

  const [isLoading, setIsLoading] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false);
  
  

  const [open, setOpen] = useState(false);
  const handleOpen = () => {setOpen(true)}
  const handleClose = () => {setOpen(false)}
    
  

  const fullName = auth.user.name;
  const [firstName, lastName] = fullName.split(" ");

  const role = auth.user.role;
  const Role = role.charAt(0).toUpperCase() + role.slice(1);

  // Fetching all news for counting
  useEffect(() => { 
    const fetchNews = async () => {
      // setIsLoading(true)
      try {
        const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/news');
        const responseData = await response.json();
        setNews(responseData.news)
        setIsLoaded(true);

      } catch (err) {
        console.log(err)
        setIsLoading(false)
      }     
    };
    fetchNews();
  }, [])



   // Fetching all users
   useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/users');
        const responseData = await response.json();
        setIsUser(responseData.users)
        setIsLoaded(true);

      } catch (err) {
        console.log(err)
      }
      
    };
    fetchUsers();
  }, [])

  // Fetching all mend data for counting
  useEffect(() => {
    const fetchMend = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/mend');
        const responseData = await response.json();
        setMend(responseData.mend);
        setIsLoaded(true);

      } catch(err) {
        console.log(err)
      }
    }
    fetchMend();
  },[]);

  // Fetching all course data for counting
  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/course');
        const responseData = await response.json();
        setCourse(responseData.course);
        setIsLoaded(true);

      } catch(err) {
        console.log(err)
      }
    }
    fetchCourse();
  },[]);

  // Fetching all books data for counting
  useEffect(() => {
    const fetchAiltgal = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/books');
        const resultData = await response.json();
        setBook(resultData);
      } catch (err) {
        console.log('Failed to fetch books', err.message)
      }
    };
     fetchAiltgal();
  }, []);
  
  
  if(isLoading){
    return(
      <div>
        <h2>Loading...</h2>
      </div>
    )
  }

  if(!isLoaded){
    return <div>Article not found!</div>
  }

  return (
    <Router>
     
    <main className='admin-container'>        
      <section className='admin-section-1-container'>
        <div className='admin-profile-container'>
          <div>
            <h3 style={{margin: '0px'}}>{Role}</h3>
          </div>   
          <Admin 
            show={open}
            onCancel={handleClose}
          />
          <div className='admin_img_name_container'>
            <div className='admin_img'>
              <img 
                src={`${process.env.REACT_APP_ASSET_URL}/${user.image}`} 
                alt={user.name} 
                style={{width:'100px', height:'100px', borderRadius: '100px' }}
              />      
            </div>

            <div className='admin_name'>     
              <h3>{firstName} <br/> {lastName}</h3>
              <Button id='button-edit' onClick={handleOpen}>Edit</Button>           
            </div>
          </div>
        

          <div className='admin_email_pass'>
            <div className='admin_email'>
              <div style={{marginRight: '10px'}}><MdAttachEmail /></div> 
              <div>Batsurenb30@gmail.com</div>            
            </div>

            <div className='admin_phone'>
              <div  style={{marginRight: '10px'}}><FaPhoneAlt /></div>        
              <div> +1 (587)-973-0508</div>
            </div>

            <div className='admin_address'>
              <div  style={{marginRight: '10px'}}> <FaAddressCard /> </div>    
              <div>550-130 New Brighton Way SE <br/> Calgary AB T2Z 1H8</div>       
            </div>
          </div>
        </div>
       
        <div className='admin-category-container'>
          <h4>Category</h4>
          <ul>
            <Link to='/admin/news' style={{textDecoration: 'none'}}>
              <li>News</li>
            </Link>
            <Link to='/admin/users' style={{textDecoration: 'none'}}>
              <li>Users</li>
            </Link>
            <Link to='/admin/courses' style={{textDecoration: 'none'}}>
              <li>Courses</li>
            </Link>
            <Link to='/admin/mend' style={{textDecoration: 'none'}}>
              <li>Greeatings</li>
            </Link>
            <Link to='#' style={{textDecoration: 'none'}}>
              <li>Datsanguud</li>
            </Link>
          </ul>
        </div>
      </section>

      <section className='admin-section-2-container'>
        <h1>Admin Dashboard</h1>
        {/* <h4>Analytics</h4>  */}
        <div className='admin-analytic-container'>
        
          <div className='admin-analytic-default-controller'>
            <div className='admin-totals'>
              <h3>Total Users </h3> {isUser.length}
            </div>
            <div className='admin-totals'>
              <h3>Total News</h3> {news.length}
            </div>
            <div className='admin-totals'>
              <h3>Total Greetings</h3> {mend.length}
            </div>
            <div className='admin-totals'>
              <h3>Total Courses</h3> {course.length}
            </div>
            <div className='admin-totals'>
              <h3>Total Ailtgal</h3> {book.length}
            </div>
          </div>

         
          <div className='admin-analytic-mobile-controller'>

            <div className='admin-total-user-news'>
              <div className='admin-totals'>
                <h3><span>Total</span> Users: </h3> {isUser.length}
              </div>
              <div className='admin-totals'>
                <h3><span>Total</span> News:</h3> {news.length}
              </div>
            </div>

            <div className='admin-total-greating-courses'>
              <div className='admin-totals'>
                <h3><span>Total</span> Greetings</h3> {mend.length}
              </div>
              <div className='admin-totals'>
                <h3><span>Total</span> Courses</h3> {course.length}
              </div>
            </div>
            
          </div>
        </div>

        <div className='admin-lists-container'> 
         <Switch>         
            {/* <Route path='/admin/news'><NewsHandler /></Route> */}
            <Route path='/admin/news' component={NewsHandler}/>
            <Route path='/admin/users'>  <UserHandler />   </Route>
            <Route path='/admin/mend'>   <MendHandler />   </Route>
            <Route path='/admin/courses'><CourseHandler /> </Route>
            <Route>
              <div className='admin-lists-default'>Select a category to view details.</div>
            </Route>
          </Switch> 
  
        </div>
      </section>
    </main> 
   
    </Router>
  )
}

export default AdminDashboard;

